<template>
  <div class="input__container">
    <div class="input__header">
      <label class="header__text">
        {{ title }}
        <span v-if="required"> &nbsp;*</span>
      </label>
      <div
        v-if="maxSymbols > 0 && (!invalid || !invalidText)"
        class="header__max"
      >
        Максимум {{ maxSymbols }} символов
      </div>
      <div v-if="invalid && invalidText" class="header__invalid">
        {{ invalidText }}
      </div>
    </div>
    <input
      v-if="type !== 'textarea'"
      :value="value"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :type="type"
      :maxlength="maxSymbols"
      :minlength="minSymbols"
      :class="['input__input', { invalid: invalid }]"
      @input="onInput($event.target.value)"
    />
    <textarea
      v-else
      :value="value"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :maxlength="maxSymbols"
      :minlength="minSymbols"
      :class="['input__textarea', { invalid: invalid }]"
      @input="onInput($event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'PartnerInput',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
    maxSymbols: {
      type: Number,
      default: undefined
    },
    minSymbols: {
      type: Number,
      default: 1
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    invalidText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text',
      validator: function (v) {
        return ['text', 'url', 'textarea'].includes(v);
      }
    }
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
    }
  }
};
</script>

<style scoped lang="scss">
@import 'style/utils';

.input {
  &__container {
    @include uiFont;
    margin-top: 16px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    @extend %text-500-12;
    color: $ui-gray-middle;

    .header {
      &__text > span {
        color: $ui-red;
        vertical-align: top;
      }

      &__invalid {
        color: $ui-red;
        margin-left: 10px;
      }
    }
  }

  &__input,
  &__textarea {
    @include uiFont;
    @extend %text-400-14;
    width: 100%;
    color: $ui-black;
    border: unset;
    border-radius: 4px;
    padding: 14px 16px;
    background: #f7f7fb;
    margin-top: 5px;

    &::placeholder {
      color: $ui-light-grey-4-5-contrast;
    }

    &.invalid {
      border: thin solid $ui-red;
    }
  }
  &__textarea {
    resize: none;
  }
}
</style>
